import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubscribeStatus('Subscribing...');
    
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5e5oendcu97hjrn4dfg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      if (response.ok) {
        setSubscribeStatus('Thank you for subscribing!');
        setEmail('');
        setTimeout(() => setSubscribeStatus(''), 3000);
      } else {
        setSubscribeStatus('Error. Please try again.');
      }
    } catch (error) {
      setSubscribeStatus('Error. Please try again.');
    }
  };

  return (
    <footer id="contact" className="py-16 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="bg-[#0A0A0A] rounded-3xl p-16 relative overflow-hidden">
          {/* Background Text */}
          <div className="absolute bottom-0 left-0 right-0 text-center">
            <p className="text-[120px] font-bold text-white/5 leading-none">FINE FRANK</p>
          </div>

          {/* Content Grid */}
          <div className="relative z-10 grid grid-cols-12 gap-12">
            {/* Column 1 - CTA */}
            <div className="col-span-4">
              <h3 className="text-4xl font-bold text-white leading-tight">
                Start Your<br />Project Today
              </h3>
            </div>

            {/* Column 2 - Services */}
            <div className="col-span-2">
              <h4 className="text-lg font-semibold text-white mb-6">Services</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    Handyman Services
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    Residential Construction
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    Commercial Construction
                  </a>
                </li>
                <li>
                  <a href="#cabinets" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    Fine Frank Cabinets
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    Emergency Repairs
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 - Connect */}
            <div className="col-span-2">
              <h4 className="text-lg font-semibold text-white mb-6">Connect</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                    <span>Instagram</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-line text-lg"></i>
                    <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-home-smile-line text-lg"></i>
                    <span>Houzz</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 4 - Newsletter */}
            <div className="col-span-4">
              <p className="text-white text-sm mb-4 leading-relaxed">
                Get project ideas and<br />exclusive offers
              </p>
              <form onSubmit={handleSubscribe} className="flex gap-2" data-readdy-form id="newsletter-form">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                  className="flex-1 px-4 py-3 bg-transparent border border-white/30 text-white placeholder-gray-500 rounded-full focus:outline-none focus:border-white/60 text-sm"
                />
                <button
                  type="submit"
                  className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-arrow-right-line text-gray-900 text-xl"></i>
                </button>
              </form>
              {subscribeStatus && (
                <p className="text-[#FF6B4A] text-sm mt-2">{subscribeStatus}</p>
              )}
            </div>
          </div>

          {/* Bottom Section */}
          <div className="relative z-10 mt-16 pt-8 border-t border-white/10 flex justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2024 Fine Frank Home Improvement. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
